import React from "react";
import { Box, Tooltip } from "@mui/material";
import UpdateIcon from "@mui/icons-material/Update";

export default function UpdateIconDesign({
  size = 30,
  color = "#4F46E5",
  onClick,
}) {
  return (
    <Tooltip title="Update" arrow>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onClick ? "pointer" : "default",
          "&:hover": {
            backgroundColor: "#fff",
            border: `2px solid ${color}`,
            "& .icon": {
              color: color,
            },
          },
        }}
        onClick={onClick}
      >
        <UpdateIcon
          className="icon"
          sx={{ color: "#fff", fontSize: size * 0.6 }}
        />
      </Box>
    </Tooltip>
  );
}
